module.exports = __webpack_public_path__ + "img/document-outline.210fc1f8.svg";